<script setup lang="ts">
import { RouterView } from "vue-router"

import { useSessionStore } from "@/entities/session"
import { AppNav } from "@/widgets/app-nav"

const session = useSessionStore()
</script>

<template>
  <AppNav v-if="session.isAuthenticated" />
  <RouterView />
</template>
